import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';

import { ToWords } from 'to-words';
const logo = require('../Images/FullLogo_NoBuffer__4_-removebg-preview.png');

// Styles
const styles = StyleSheet.create({

  page: {
    fontSize: 10,
    padding: 30,
    fontFamily: 'Helvetica',
    lineHeight: 1.4,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
    borderBottomWidth: 2,
    borderBottomColor: '#f0a027',
    paddingBottom: 10,
  },
  companySection: {
    flex: 2,
  },
  invoiceInfo: {
    flex: 1,
    alignItems: 'flex-end',
  },
  logo: {
    width: 120,
  },
  companyName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginTop: 5,
    marginBottom: 5,
  },
  companyDetails: {
    fontSize: 9,
    color: '#666',
    marginTop: 4,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#f0a027',
    marginVertical: 8,
  },
  table: {
    width: '100%',
    marginVertical: 5,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    alignItems: 'center',
    minHeight: 24,
  },
  tableColHeader: {
    width: '25%',
    fontWeight: 'bold',
    backgroundColor: '#f8f8f8',
    paddingVertical: 5,
    paddingHorizontal: 4,
    color: '#333',
  },
  tableCol: {
    width: '25%',
    paddingVertical: 5,
    paddingHorizontal: 4,
    color: '#444',
  },
  amountSection: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 15,
  },
  totalAmount: {
    width: '30%',
    border: '1',
    borderColor: '#f0a027',
    padding: 8,
    backgroundColor: '#fff9f0',
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    fontSize: 8,
    color: '#666',
    textAlign: 'center',
    borderTopWidth: 1,
    borderTopColor: '#eee',
    paddingTop: 8,
  },
});

const toWords = new ToWords();
const converttowords = (amount) => {
  if (!amount || isNaN(amount)) return 'Zero Rupees';
  let words = toWords.convert(amount, { currency: true, ignoreDecimal: true });
  return words;
};


const InvoicePDF = ({ invoiceData}) => {
  if (!invoiceData) {
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <Text>No invoice data available.</Text>
        </Page>
      </Document>
    );
  }

const rideDateObj = invoiceData?.ride_date_and_time
    ? new Date(invoiceData.ride_date_and_time)
    : new Date();
  const rideDate = rideDateObj.toISOString().split('T')[0]; // YYYY-MM-DD
  const rideTime = rideDateObj.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  // Format today's date as dd-MMM-yyyy
const today = new Date();
const formattedToday = today.toLocaleDateString('en-GB', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});

const getBookingRef = (bookingData) => {
  return bookingData?.booking_id || 'TGH-CAB-0001';
};

const getInvoiceNumber = (bookingData) => {
  return bookingData?.invoiceNumber || 'TGH-INV-0001';
};

  const paymentAmount = invoiceData?.payment_amount ?? 0;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
       
        <View style={styles.header}>
          <View style={styles.companySection}>
            <Image style={styles.logo} src={logo} />
            <Text style={styles.companyName}>The Great Himalayas Cabs</Text>
            <Text style={styles.companyDetails}>
              Siliguri, Darjeling(Dist), West Bengal, 734001{'\n'}
              GSTIN: 09AAHCH9024K1Z7{'\n'}
              Phone: +91 98835 87965 | Email: TGH_Operations@thegreathimalayas.com
            </Text>
          </View>

        <View style={styles.invoiceInfo}>
            <Text style={{ ...styles.sectionTitle, marginTop: 0 }}>INVOICE</Text>
            <Text style={styles.companyDetails}>
              Invoice #: {getInvoiceNumber(invoiceData)}
              {'\n'}
              Booking Ref: {getBookingRef(invoiceData)}
              {'\n'}
              Date: {invoiceData?.date || formattedToday}
              {'\n'}
           
            </Text>
          </View>
        </View>

        {/* Passenger Details */}
        <Text style={styles.sectionTitle}>Passenger Information</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableColHeader}>Passenger Name</Text>
            <Text style={styles.tableColHeader}>Contact Details</Text>
            <Text style={styles.tableColHeader}>Travel Details</Text>
            <Text style={styles.tableColHeader}>Seat Information</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCol}>
              {invoiceData?.userid?.name || 'N/A'}
            </Text>
            <Text style={styles.tableCol}>
              {invoiceData?.userid?.email || 'N/A'}
              {'\n'}
              {invoiceData?.userid?.phone_number || 'N/A'}
            </Text>
            <Text style={styles.tableCol}>
              {rideDate || '06-Feb-2025'}
              {'\n'}
              {invoiceData?.route?.name}
              {'\n'}
              Time: {rideTime}
            </Text>
            <Text style={styles.tableCol}>
              {invoiceData?.selected_seats
                ?.length > 0
                ? `${invoiceData.selected_seats
                  .join(', ')} (${invoiceData.selected_seats
                    .length} Passenger${invoiceData.selected_seats
                      .length > 1 ? 's' : ''})`
                : 'N/A'}
            </Text>
          </View>
        </View>

        {/* Vehicle & Driver Details */}
        <Text style={styles.sectionTitle}>Vehicle & Driver Details</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableColHeader}>Vehicle Number</Text>
            <Text style={styles.tableColHeader}>Vehicle Type</Text>
            <Text style={styles.tableColHeader}>Driver Name</Text>
            <Text style={styles.tableColHeader}>Driver Contact</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCol}>
              {invoiceData?.vehicleId?.reg_no || 'NA'}
            </Text>
            <Text style={styles.tableCol}>
              {invoiceData?.vehicleId?.brand_name || 'NA'} {invoiceData?.vehicleId?.model_name || 'NA'}
            </Text>
  
            <Text style={styles.tableCol}>
              {invoiceData?.driverId?.name || 'NA'}
            </Text>
            <Text style={styles.tableCol}>
             {/*} {invoiceData?.driverId?.phone_number || '+91 XXXXX XXXXX'} */}
             { '+91 9883587965'}
            </Text>
          </View>
        </View>

        {/* Fare Details */}
        <Text style={styles.sectionTitle}>Fare Details</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableColHeader}>Description</Text>
            <Text style={styles.tableColHeader}>Amount (Rs)</Text>
            <Text style={styles.tableColHeader}>Tax</Text>
            <Text style={styles.tableColHeader}>Total (Rs)</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCol}>Base Fare</Text>
            <Text style={styles.tableCol}>{(paymentAmount / 1.05).toFixed(2)|| '0.00'}</Text>
            <Text style={styles.tableCol}>
              CGST 2.5%
              {'\n'}
              SGST 2.5%
            </Text>
            <Text style={styles.tableCol}>{paymentAmount.toFixed(2) || '0.00'}</Text>
          </View>
        </View>

        {/* Total Amount */}
        <View style={styles.amountSection}>
          <View style={styles.totalAmount}>
            <Text style={{ fontWeight: 'bold' }}>GRAND TOTAL</Text>
            <Text style={{ fontSize: 14, marginTop: 4 }}>
              Rs. {paymentAmount.toFixed(2) || '0.00'}
            </Text>
            <Text style={{ fontSize: 8, marginTop: 4 }}>{converttowords(paymentAmount)}</Text>
          </View>
        </View>


        {/* Footer */}
        <View style={styles.footer}>
          <Text>
            Thank you for choosing TGH Cabs! {'\n'}• This is a computer generated
            invoice and does not require physical signature {'\n'} • 
            Terms & Conditions: Subject to Siliguri jurisdiction. Cancellation charges
            apply as per policy.{'\n'} • 
            Driver Details Will be shared before 24 hours of ride begins.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default InvoicePDF;
